import type { ErpModule } from '@/api/platform.api';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { isPlatformAdminRoute } from '@/config/moduleDefaults';
import { isLegacyGlobalWorkRoute } from '@/constants/globalWorkspaceRoutes';
import { localizeModuleLabel } from '@/i18n/navLabel';
import { i18n } from '@/i18n';

/** API `module` query — omit on cross-module org admin and global work routes. */
export function resolveNotificationModuleParam(
  pathname: string,
  activeModule: ErpModule | null,
): ErpModule | undefined {
  if (isPlatformAdminRoute(pathname)) return undefined;
  if (isLegacyGlobalWorkRoute(pathname)) return undefined;
  return activeModule ?? undefined;
}

export function notificationPanelTitle(module: ErpModule | undefined): string {
  if (!module) {
    return i18n.t('panel.title', { ns: 'notifications', defaultValue: 'Notifications' });
  }
  const label = localizeModuleLabel(module);
  return i18n.t('panel.moduleTitle', {
    ns: 'notifications',
    module: label,
    defaultValue: `${getModuleEntryByErpModule(module)?.label ?? module} notifications`,
  });
}
